/* global */
// BEGIN VENDOR ASSETS
// Import theme specific vendor assets here, this should be a rare case
// END VENDOR ASSETS

// BEGIN INDIVIDUAL COMPONENT SCRIPTS
// NOTE: If your component does not need specific script functiionality there
// is no need to include the default scripts from the component starter
// import '../../components/component-collagecontent/src/scripts/_base.js'
// END INDIVIDUAL COMPONENT SCRIPTS

(($) => {
  window.COMPONENTSCHILD || (window.COMPONENTSCHILD = {})

  COMPONENTSCHILD.init = () => {
    console.log('HELLO FROM COMPONENTS CHILD THEME')

    // $('[data-property-field]').attr('value','{{ property }}').change()
    $('select[data-review-select], select[data-social-select]').on('change', function () {
      console.log('a click has happened.')
      var Url = $(this).val()

      if (Url != '*') {
        var win = window.open(Url, '_blank');
        if (win) {
          win.focus();
        }
      }
    })
  }

  $(document).ready(() => {
    COMPONENTSCHILD.init()
  })
}
)(jQuery)
